import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Row, Col, Form, Dropdown } from "react-bootstrap";
import SimpleBar from "simplebar-react";
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import apiUrl from 'slices/apiEndpoint'
import { selectLoading, setLoading } from 'slices/contract/reducer'
import { getDecodeId, getUserName } from 'slices/userProfile/thunk'
import { Client } from "@twilio/conversations";
import axios from 'axios'
import decodeJwt from 'helpers/jwt-token-access/jwtdecode'
import {  sendTwillioMSG } from 'pages/Contracts/messages/chat'

//img
import avatar2 from "assets/images/users/avatar-2.jpg";
import api from "./api";

const ChatModal = ({ show,userName,project, handleClose,OtherId,userType }: any) => {
console.log(show)
    const [searchParams]  = useSearchParams()
    const [chatClient, setChatClient] = useState<Client | null>(null);
    const [messages, setMessages] = useState<any[]>([]);
    const [messageInput, setMessageInput] = useState("");
    const [conversation, setConversation] = useState<any>(null);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);

    const OtherName = userName // Get the 'id' parameter

    const otherUserIdentity = `user_${OtherId}`
    const idendity = `user_${getDecodeId()}`
   const chatName ="hii"
   const loading = useSelector(selectLoading)
   const dispatch = useDispatch()
   const getChatID = (firstID:any,secondID:any) =>{
    const highestValue = Number(firstID) >Number(secondID) ?firstID:secondID
    const lowestValue = Number(firstID) <Number(secondID) ?firstID:secondID
    const chatID = `${highestValue}_${lowestValue}_leadID-${project.id}`
    
    return chatID
  }
  
    useEffect(() => {
  if(show){
    const fetchToken = async () => {
        try {
          dispatch(setLoading(true))
          const res = await fetch(`${apiUrl}/chat/generate-token`, {
            method: "POST",
            headers: { "Content-Type": "application/json" ,
        
        },
            body: JSON.stringify({ identity: idendity }),
          });
          const data = await res.json();
  
          const client = new Client(data.token);
          setChatClient(client);
  
          client.on("stateChanged", async (state) => {
            if (state === "initialized") {
              getOrCreateConversation(client);
            }else{
          dispatch(setLoading(false))
  
            }
          });
        } catch (error) {
          dispatch(setLoading(false))
          console.error("❌ Error fetching token:", error);
        }
      };
      fetchToken();

  }else{
    setMessages([])
    setMessageInput("")
    setConversation(null)
  }

  
    }, [show]);
    const registerUserIfNeeded = async (identity: string) => {
      try {
        // 🔹 Check if the user exists via your Node.js API
        const res = await api.get(`/chat/check-user/${identity}`);
    
        if (res.data.registered) {
          console.log(`🟢 User exists in Twilio: ${identity}`);
        } else {
          console.log(`🟡 User not found. Registering: ${identity}`);
    
          // 🔹 Register user via your Node.js API
          await api.post(`/chat/register-user`, { identity });
    
          console.log(`✅ User registered: ${identity}`);
        }
      } catch (error: any) {
        console.error("❌ Error checking/registering user:", error);
      }
    };
    const chatID = getChatID(getDecodeId(),OtherId)
   
    const getOrCreateConversation = async (client: Client) => {
        try {
            let convo = await client.getConversationByUniqueName(chatID).catch(async () => {
                console.log("❌ No existing conversation found, creating a new one...");
                const friendlyName = `${getDecodeId()}-${getUserName()}_${OtherId}-${OtherName}_${project.lead_sub_cat}`;
                const newConvo = await client.createConversation({ uniqueName: chatID, friendlyName });
                console.log("🆕 New conversation created:", newConvo.sid);
                await newConvo.join();
                return newConvo;
            });
    
            const participants = await convo.getParticipants()
    
            const addUserToConversation = async (identity: string) => {
                if (!participants.some((p: any) => p.identity === identity)) {
                    await registerUserIfNeeded(identity);
                    await convo.add(identity);
                }
            };
    
            await addUserToConversation(`user_${getDecodeId()}`);
            await addUserToConversation(`user_${OtherId}`);
    
            console.log("✅ Participants added successfully!");
            setConversation(convo);
    
            // Load previous messages
            loadMessages(convo);
    
            // 🔥 Listen for new messages and update state without re-rendering everything
            convo.on("messageAdded", (message: any) => {
                console.log("📩 New message received:", message.body);
                setMessages((prevMessages) => [...prevMessages, message]);
            });
    
        } catch (error) {
            console.error("❌ Error getting/creating conversation:", error);
        } finally {
            dispatch(setLoading(false));
        }
    };
    
  
    const loadMessages = async (convo: any) => {
        console.log("📩 Loading messages...");
        const messages = await convo.getMessages();
        console.log("✅ Messages loaded:", messages.items.length);
    
        setMessages(messages.items);  // ✅ Only updates state when messages are fetched
    };
    
  
    const sendMessage = async () => {
        if (!conversation || !messageInput.trim()) return;
    
        try {
            await conversation.sendMessage(messageInput);
            setMessageInput("");
        } catch (error) {
            console.error("❌ Error sending message:", error);
        }
    };
    const messagesEndRef = useRef<HTMLDivElement | null>(null);
    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
      };


      useEffect(() => {
        if(messages.length>4){
            scrollToBottom();

        }
      }, [messages]);
      
    return (
        <React.Fragment>
            <div className={`email-chat-detail ${show ? 'd-block' : 'd-none'}`} id="emailchat-detailElem">
                <Card className=" mb-0 overflow-hidden">
                    <Card.Header className="align-items-center d-flex bg-primary-subtle text-primary p-3">
                        <div className="flex-grow-1">
                            <h5 className="fs-md text-primary-emphasis profile-username">{userName}</h5>
                            <p className="mb-0 fs-sm lh-1">{userType}</p>
                        </div>
                        <div className="flex-shrink-0">
                            <div className="mt-n1">
                                <button type="button" className="btn btn-link btn-icon btn-sm text-primary fs-lg text-decoration-none rounded-circle bg-primary-subtle bg-opacity-10" id="emailchat-btn-close" onClick={handleClose}><i className="ri-close-fill"></i></button>
                            </div>
                        </div>
                    </Card.Header>

                    <Card.Body className="p-0">
                        <div id="users-chat">
                            <SimpleBar style={{ height: "250px" }}>
                                <div className="chat-conversation p-3" id="chat-conversation" >
                                <ul className="list-unstyled chat-conversation-list chat-sm">
    {messages.map((msg) => (
        <li key={msg.sid} className={`chat-list ${msg.author === idendity ? "right" : "left"}`}>
            <div className="conversation-list">
                {msg.author !== idendity && (
                    <div className="chat-avatar">
                        <img src={avatar2} alt="User Avatar" />
                    </div>
                )}
                <div className="user-chat-content">
                    <div className="ctext-wrap">
                        <div className="ctext-wrap-content">
                            <p className="mb-0 ctext-content">{msg.body}</p>
                        </div>
                    </div>
                    <div className="conversation-name">
                        <small className="text-muted time">
                        {new Date(msg.dateCreated).toLocaleTimeString("en-US", {
  hour: "2-digit",
  minute: "2-digit",
  hour12: true,
})}
                        </small>
                        <span className="text-success check-message-icon">
                            <i className="ri-check-double-line align-bottom"></i>
                        </span>
                    </div>
                </div>
            </div>
        </li>
    ))}
      <div ref={messagesEndRef} />

</ul>

                                </div>
                            </SimpleBar>
                        </div>

                        <div className="border-top border-top-dashed">
                            <Row className="g-2 mx-3 mt-2 mb-3">
                                <Col className="col">
                                    <div className="position-relative">
                                    <Form.Control
    type="text"
    className="border-light bg-light"
    placeholder="Enter Message..."
    value={messageInput}
    onChange={(e) => setMessageInput(e.target.value)}
    onKeyDown={(e) => e.key === "Enter" && sendMessage()} 
/>
                                    </div>
                                </Col>
                                <Col className="col-auto">
                                    <Button disabled={loading} onClick={sendMessage} variant="secondary" type="submit">{loading?"Loading...":<i className="mdi mdi-send"></i>}</Button>
                                </Col>
                            </Row>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </React.Fragment>
    );
}

export default ChatModal;